import styled from "styled-components";
import { Heading1, SubHeading, CTAButtonWrapper } from "../../../../common/styled-components/styled-components";
import { breakpoints, device } from '../../../../../../app/js/utils/responsive_utilities';
import { white, deepCoveDark } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../common/mixins/mixin';
import { moveElementHorizontally} from "../../../../common/functions/animations";

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${deepCoveDark};
  ${styledFont("Graphie")}
  padding-top: 2rem;
  position: relative;
  @media ${device.Tablet} {
    padding-top: 0;
  }
  @media ${device.Desktop} {
    padding-top: 4rem;
  }
`

export const HeadingText = styled(Heading1)`
  color: ${white};
  margin: auto;
  padding-top: 0.5rem;
  ${styledFont("Graphie", 2.8, 3.2, 7)}

  @media ${device.Desktop} {
    ${styledFont("Graphie", 4, 4.8, 7)}
  }
`

export const SubHeadingText = styled(SubHeading)`
  width: 90%;
  color: ${white};
  margin: auto;
  padding-top: 0.5rem;
  ${styledFont("Graphie", 1.6, 2, 6)}

  @media ${device.Desktop} {
    ${styledFont("Graphie", 2, 2.4, 6)}
  }

`

export const LearningRail = styled.div`
  height: 10rem;
  padding-top: 9.4rem;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  >img{
    height: 100%;
    position: relative;
    animation : ${moveElementHorizontally({x1: 100, x2:0, unit:'%'})} 3s ease;
    animation-delay: ${props => props.delay};
    z-index: 2
  }

  @media ${device.PhoneLandscape}{
    width: 100%;
    justify-content: center;
    padding-top: 4.4rem;
  }

  @media (min-width: ${breakpoints.md}px){
    min-height: 20rem;
    height: 100%;
    justify-content: center;
    >img{
      width: 95%;
    }
  }
`

export const ButtonWrapper = styled(CTAButtonWrapper)`
  padding: 11rem 0 10rem 0;

  @media ${device.PhoneLandscape}{
    padding: 6rem 0 10rem 0;
  }

  @media ${device.Desktop}{
    padding: 18rem 0 10rem 0;
  }
  > div{
    z-index: 2;
    width: 30rem;
  }
`

export const BackgroundWrapper = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;
  
  >img{
    width: 100%;
    display: block;
  }
`
